import { render, staticRenderFns } from "./RegisterScreen.vue?vue&type=template&id=59a89c5c"
import script from "./RegisterScreen.vue?vue&type=script&lang=js"
export * from "./RegisterScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports